function TableRowsServiceSpareParts({ rowsData, setRowsData, readOnly = false }) {
    const updateRow = (index, field, value) => {
        const next = [...rowsData];
        const row = { ...next[index], [field]: value };
        const qty = Number(row.quantity) || 0;
        const unitCost = Number(row.unit_cost) || 0;
        if (field === 'quantity' || field === 'unit_cost') {
            row.total_cost = Number((qty * unitCost).toFixed(2));
        }
        next[index] = row;
        setRowsData(next);
    };

    const addRow = () => {
        setRowsData([
            ...rowsData,
            {
                line_no: rowsData.length + 1,
                part_name: '',
                part_number: '',
                quantity: 0,
                unit_cost: 0,
                total_cost: 0,
                user_remarks: '',
            },
        ]);
    };

    const removeRow = (index) => {
        const next = rowsData.filter((_, i) => i !== index).map((row, idx) => ({ ...row, line_no: idx + 1 }));
        setRowsData(next.length ? next : [{
            line_no: 1, part_name: '', part_number: '', quantity: 0, unit_cost: 0, total_cost: 0, user_remarks: '',
        }]);
    };

    return (
        <div className="table-responsive">
            <table className="table table-bordered table-sm">
                <thead>
                    <tr>
                        {!readOnly && <th style={{ width: 40 }}>+</th>}
                        <th>Part Name</th>
                        <th>Part No</th>
                        <th>Qty</th>
                        <th>Unit Cost</th>
                        <th>Total</th>
                        <th>Remarks</th>
                        {!readOnly && <th style={{ width: 40 }}>X</th>}
                    </tr>
                </thead>
                <tbody>
                    {rowsData.map((row, index) => (
                        <tr key={`spare-${index}`}>
                            {!readOnly && (
                                <td>
                                    {index === 0 && (
                                        <button type="button" className="btn btn-success btn-sm" onClick={addRow}>+</button>
                                    )}
                                </td>
                            )}
                            <td>
                                <input
                                    className="form-control form-control-sm"
                                    value={row.part_name || ''}
                                    onChange={(e) => updateRow(index, 'part_name', e.target.value)}
                                    readOnly={readOnly}
                                />
                            </td>
                            <td>
                                <input
                                    className="form-control form-control-sm"
                                    value={row.part_number || ''}
                                    onChange={(e) => updateRow(index, 'part_number', e.target.value)}
                                    readOnly={readOnly}
                                />
                            </td>
                            <td>
                                <input
                                    type="number"
                                    step="0.001"
                                    className="form-control form-control-sm"
                                    value={row.quantity || 0}
                                    onChange={(e) => updateRow(index, 'quantity', e.target.value)}
                                    readOnly={readOnly}
                                />
                            </td>
                            <td>
                                <input
                                    type="number"
                                    step="0.01"
                                    className="form-control form-control-sm"
                                    value={row.unit_cost || 0}
                                    onChange={(e) => updateRow(index, 'unit_cost', e.target.value)}
                                    readOnly={readOnly}
                                />
                            </td>
                            <td>
                                <input
                                    type="number"
                                    step="0.01"
                                    className="form-control form-control-sm"
                                    value={row.total_cost || 0}
                                    onChange={(e) => updateRow(index, 'total_cost', e.target.value)}
                                    readOnly={readOnly}
                                />
                            </td>
                            <td>
                                <input
                                    className="form-control form-control-sm"
                                    value={row.user_remarks || ''}
                                    onChange={(e) => updateRow(index, 'user_remarks', e.target.value)}
                                    readOnly={readOnly}
                                />
                            </td>
                            {!readOnly && (
                                <td>
                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => removeRow(index)}>x</button>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default TableRowsServiceSpareParts;
